import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { CreateAccountInfoServiceRequest } from '@musinsa/services-curator';
import {
  createAccountInfoService,
  getAccountInfoService,
  getBanksService,
} from '@musinsa/services-curator';

export const accountInfoFactory = createQueryKeys('accountInfo', {
  /**
   * 정산정보 조회
   */
  get: {
    queryKey: null,
    queryFn: () => getAccountInfoService(),
  },

  /**
   * 정산정보 등록/수정
   */
  create: (data: CreateAccountInfoServiceRequest) => ({
    queryKey: [{ data }],
    queryFn: () => createAccountInfoService(data),
  }),

  /**
   * 은행 목록 조회
   */
  banks: {
    queryKey: null,
    queryFn: () => getBanksService(),
  },
});
